import React from 'react';
import { View } from 'react-native';
import {verticalScale} from 'react-native-size-matters';

export const Separator = props => (
    <View style={{flexDirection: 'row', height: verticalScale(props.distance)}} />
  );
